<template>
  <div class="dealer-dialog-form staging-config">
    <dealer-dialog-header :name="dealerName" :hqid="dealerHqid" />
    <el-form ref="form" :model="formModel" label-width="0">
      <div class="switch-block">
        <div class="switch-row">
          <span class="switch-row__label">花呗分期</span>
          <el-switch v-model="formModel.open_fq_pay_hua_bei" active-value="1" inactive-value="0" />
        </div>
        <div class="switch-row">
          <span class="switch-row__label">支付宝信用卡分期</span>
          <el-switch v-model="formModel.open_fq_pay_credit_card" active-value="1" inactive-value="0" />
        </div>
      </div>
      <div class="inline-form-row" style="margin-top: 20px">
        <label class="inline-form-row__label">
          <span class="required">*</span>可分期订单金额:
        </label>
        <div class="inline-form-row__control">
          <span class="prefix">金额大于</span>
          <el-input
            v-model="minPriceInput"
            class="inline-input"
            placeholder="请填写内容"
            maxlength="8"
            @input="onMinPriceInput"
          />
          <span class="suffix">元</span>
        </div>
      </div>
    </el-form>

    <template v-if="formModel.open_fq_pay_hua_bei === '1'">
      <div class="sub-merchant-section">
        <div class="inline-form-row">
          <label class="inline-form-row__label">二级商户名称:</label>
          <div class="inline-form-row__control">
            <el-input
              v-model="formModel.sub_mer_name"
              class="sub-merchant-input"
              placeholder="请输入二级商户名称"
              maxlength="100"
            />
          </div>
        </div>
        <div class="inline-form-row">
          <label class="inline-form-row__label">二级商户ID:</label>
          <div class="inline-form-row__control">
            <el-input
              v-model="formModel.sub_mer_id"
              class="sub-merchant-input"
              placeholder="请输入二级商户ID"
              maxlength="64"
            />
          </div>
        </div>
        <p class="sub-merchant-section__notice">二级商户名称、二级商户ID均为非必填；若开启了商贴，则需要必填</p>
      </div>

      <div class="fee-type-section">
        <div class="inline-form-row">
          <label class="inline-form-row__label">费率选择:</label>
          <div class="inline-form-row__control">
            <el-select
              v-model="formModel.fee_type"
              class="fee-type-select"
              placeholder="请选择费率"
              clearable
            >
              <el-option
                v-for="item in feeTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>

      <div class="contact-sections" v-loading="contactsLoading">
        <div class="list-section">
          <div class="list-section__title">商贴预算提醒接收邮箱</div>
          <div
            v-for="(item, index) in formModel.emails"
            :key="'email-' + index"
            class="list-section__row"
          >
            <el-input
              v-model="formModel.emails[index]"
              placeholder="请输入提醒接收邮箱地址"
            />
            <el-link
              v-if="formModel.emails.length > 1"
              type="primary"
              :underline="false"
              @click="removeEmail(index)"
            >删除</el-link>
          </div>
          <el-button
            v-if="formModel.emails.length < 5"
            class="list-section__add-btn"
            plain
            @click="addEmail"
          >添加邮箱地址</el-button>
          <p class="list-section__tip">参加花呗商贴活动必填，最多添加 5 条</p>
        </div>

        <div class="list-section">
          <div class="list-section__title">预算提醒接收手机</div>
          <div
            v-for="(item, index) in formModel.mobiles"
            :key="'mobile-' + index"
            class="list-section__row"
          >
            <el-input
              v-model="formModel.mobiles[index]"
              placeholder="请输入提醒接收手机号"
              maxlength="11"
              @input="onMobileInput(index)"
            />
            <el-link
              v-if="formModel.mobiles.length > 1"
              type="primary"
              :underline="false"
              @click="removeMobile(index)"
            >删除</el-link>
          </div>
          <el-button
            v-if="formModel.mobiles.length < 5"
            class="list-section__add-btn"
            plain
            @click="addMobile"
          >添加手机号</el-button>
          <p class="list-section__tip">参加花呗商贴活动商贴必填，最多添加 5 条</p>
        </div>
      </div>
    </template>

    <div class="staging-config__footer">
      <el-button type="primary" :loading="saving" @click="saveConfig">确定</el-button>
    </div>
  </div>
</template>
<script>
import { openDealer, getDealerNotifyContacts, saveDealerNotifyContacts } from '@/api/marketing'
import DealerDialogHeader from './dealer-dialog-header.vue'

const MAX_CONTACT_COUNT = 5

const FEE_TYPE_OPTIONS = [
  { value: '02', label: '标准费率线下' },
  { value: '03', label: '非盈利费率' },
  { value: '04', label: '缴费费率' },
  { value: '06', label: '行业活动费率' }
]

function normalizeStringArray (val) {
  if (Array.isArray(val)) {
    const items = val.map(v => String(v == null ? '' : v).trim()).filter(Boolean)
    return items.length ? items : ['']
  }
  if (typeof val === 'string' && val.trim()) {
    try {
      const parsed = JSON.parse(val)
      if (Array.isArray(parsed)) {
        return normalizeStringArray(parsed)
      }
    } catch (e) {
      // ignore invalid json
    }
    const items = val.split(',').map(item => item.trim()).filter(Boolean)
    return items.length ? items : ['']
  }
  return ['']
}

export default {
  name: 'StagingConfig',
  components: { DealerDialogHeader },
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dealerName: '',
      dealerHqid: '',
      saving: false,
      contactsLoading: false,
      minPriceInput: '100',
      feeTypeOptions: FEE_TYPE_OPTIONS,
      formModel: {
        open_fq_pay_hua_bei: '1',
        open_fq_pay_credit_card: '1',
        fq_pay_min_price: 100,
        sub_mer_name: '',
        sub_mer_id: '',
        fee_type: '',
        emails: [''],
        mobiles: ['']
      }
    }
  },
  mounted () {
    this.initForm()
    this.loadNotifyContacts()
  },
  watch: {
    detailData: {
      deep: true,
      handler () {
        this.initForm()
        this.loadNotifyContacts()
      }
    }
  },
  methods: {
    initForm () {
      const {
        name,
        dealer_hqid,
        open_fq_pay_hua_bei,
        open_fq_pay_credit_card,
        fq_pay_min_price
      } = this.detailData
      this.dealerName = name || ''
      this.dealerHqid = dealer_hqid || ''
      this.formModel = {
        ...this.formModel,
        open_fq_pay_hua_bei: open_fq_pay_hua_bei != null ? open_fq_pay_hua_bei : this.formModel.open_fq_pay_hua_bei,
        open_fq_pay_credit_card: open_fq_pay_credit_card != null ? open_fq_pay_credit_card : this.formModel.open_fq_pay_credit_card,
        fq_pay_min_price: fq_pay_min_price != null ? Number(fq_pay_min_price) : 100
      }
      this.minPriceInput = String(this.formModel.fq_pay_min_price)
    },
    applyMercodeInfo (info = {}) {
      this.formModel.sub_mer_name = info.sub_mer_name || ''
      this.formModel.sub_mer_id = info.sub_mer_id || ''
      this.formModel.fee_type = info.fee_type || ''
    },
    loadNotifyContacts () {
      const dealerId = this.detailData.dealer_id
      if (!dealerId) return
      this.contactsLoading = true
      getDealerNotifyContacts(dealerId)
        .then(res => {
          const data = res.data.data || {}
          this.formModel.emails = normalizeStringArray(data.emails)
          this.formModel.mobiles = normalizeStringArray(data.mobiles)
          this.applyMercodeInfo(data.dougong_pcredit_mercode_info || {})
        })
        .catch(() => {
          this.formModel.emails = ['']
          this.formModel.mobiles = ['']
          this.applyMercodeInfo()
        })
        .finally(() => {
          this.contactsLoading = false
        })
    },
    onMinPriceInput (val) {
      const digits = String(val).replace(/\D/g, '')
      this.minPriceInput = digits
      this.formModel.fq_pay_min_price = digits === '' ? '' : Number(digits)
    },
    onMobileInput (index) {
      const digits = String(this.formModel.mobiles[index]).replace(/\D/g, '')
      this.$set(this.formModel.mobiles, index, digits)
    },
    addEmail () {
      if (this.formModel.emails.length >= MAX_CONTACT_COUNT) return
      this.formModel.emails.push('')
    },
    removeEmail (index) {
      if (this.formModel.emails.length <= 1) return
      this.formModel.emails.splice(index, 1)
    },
    addMobile () {
      if (this.formModel.mobiles.length >= MAX_CONTACT_COUNT) return
      this.formModel.mobiles.push('')
    },
    removeMobile (index) {
      if (this.formModel.mobiles.length <= 1) return
      this.formModel.mobiles.splice(index, 1)
    },
    validateContactFields () {
      if (this.formModel.open_fq_pay_hua_bei !== '1') {
        return true
      }
      const emails = this.formModel.emails.map(item => item.trim()).filter(Boolean)
      const mobiles = this.formModel.mobiles.map(item => item.trim()).filter(Boolean)
      if (!emails.length) {
        this.$message.warning('请填写商贴预算提醒接收邮箱')
        return false
      }
      if (!mobiles.length) {
        this.$message.warning('请填写预算提醒接收手机')
        return false
      }
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const invalidEmail = emails.find(email => !emailReg.test(email))
      if (invalidEmail) {
        this.$message.warning('请输入正确的邮箱地址')
        return false
      }
      const mobileReg = /^1\d{10}$/
      const invalidMobile = mobiles.find(mobile => !mobileReg.test(mobile))
      if (invalidMobile) {
        this.$message.warning('请输入正确的手机号')
        return false
      }
      return true
    },
    async saveConfig () {
      const price = Number(this.formModel.fq_pay_min_price)
      if (!price || price < 100) {
        this.$message.warning('可分期订单金额不能低于 100 元')
        return
      }
      if (!this.validateContactFields()) {
        return
      }
      const emails = this.formModel.emails.map(item => item.trim()).filter(Boolean)
      const mobiles = this.formModel.mobiles.map(item => item.trim()).filter(Boolean)
      try {
        this.saving = true
        await openDealer({
          dealer_id: this.detailData.dealer_id,
          open_fq_pay_hua_bei: this.formModel.open_fq_pay_hua_bei,
          open_fq_pay_credit_card: this.formModel.open_fq_pay_credit_card,
          fq_pay_min_price: price
        })
        await saveDealerNotifyContacts(this.detailData.dealer_id, {
          emails,
          mobiles,
          dougong_pcredit_mercode_info: {
            sub_mer_name: (this.formModel.sub_mer_name || '').trim(),
            sub_mer_id: (this.formModel.sub_mer_id || '').trim(),
            fee_type: this.formModel.fee_type || ''
          }
        })
        this.$message.success('保存成功')
        this.$emit('success')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './dealer-dialog-form.scss';

.staging-config {
  padding: 0 20px 20px;

  .switch-block {
    padding-bottom: 4px;
  }

  .sub-merchant-section {
    margin-top: 24px;

    .sub-merchant-input {
      width: 100%;
      max-width: 360px;
    }

    &__notice {
      margin: 0 0 0 168px;
      padding: 8px 12px;
      font-size: 13px;
      font-weight: 600;
      color: #e6a23c;
      line-height: 1.5;
      background: #fdf6ec;
      border-left: 3px solid #e6a23c;
      border-radius: 2px;
    }
  }

  .fee-type-section {
    margin-top: 24px;

    .fee-type-select {
      width: 100%;
      max-width: 360px;
    }
  }

  .list-section {
    margin-top: 24px;

    &__title {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      line-height: 1.5;
    }

    &__row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;

      .el-input {
        flex: 1;
      }

      .el-link {
        flex-shrink: 0;
      }
    }

    &__add-btn {
      border-color: #409eff;
      color: #409eff;
    }

    &__tip {
      margin: 8px 0 0;
      font-size: 12px;
      color: #909399;
      line-height: 1.5;
    }
  }

  &__footer {
    margin-top: 32px;
    text-align: center;

    .el-button {
      min-width: 120px;
    }
  }
}
</style>
